<template>
  <div class="hld-action">
    <div class="nav-bar">
      <i class="el-icon-arrow-left back-icon" @click="goBack()"></i>
      <span class="title">霍兰德职业兴趣测评</span>
      <div class="capsule"></div>
    </div>
    <img src="@/assets/images/hld-action-header.png" width="100%" alt="" />

    <div class="description-section">
      <button class="start-test-btn" @click="startTest">开始测评 →</button>
      <div class="section-content">
        <h3>霍兰德兴趣测评</h3>
        <p>
          霍兰德职业兴趣理论从兴趣的角度出发探索职业指导的问题，明确了职业兴趣的人格观念，使得人们对于职业兴趣的认识有了质的变化。在霍兰德职业兴趣理论出来之前，职业兴趣和职业环境二者分别独立存在，正是霍兰德的总结，创造性地将它们联合到一起。
        </p>
        <p>
          霍兰德职业兴趣理论将人格类型分为研究型(I)、艺术型(A)、社会型(S)、企业型(E)、传统型(C)、现实型(R)六个维度，不同的维度组合成不同的职业兴趣特征倾向，并由此来分析测试人在某些领域和岗位上更加擅长，也更容易获取职业成就。
        </p>
      </div>
      <img
        src="@/assets/images/hld-action-bottom.png"
        class="hld-action-bottom"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "HLDAction",
  methods: {
    goBack() {
      this.$router.push("/hld-home");
    },
    startTest() {
      this.$router.push("/hld-qa");
    },
    viewResult() {
      const openid =
        localStorage.getItem("openId") || localStorage.getItem("openid") || "";
      if (openid) {
        this.$router.push({
          path: "/hld-result",
          query: { openid: openid, wjId: "2" },
        });
      } else {
        alert("暂无微信登录信息，请先完成登录");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.back-btn {
  position: absolute;
  top: 10px;
  left: 20px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: #333;
}
.hld-action {
  position: relative;
  height: 100vh;
  background: linear-gradient(135deg, #e6f0ff 0%, #f0f4ff 100%);
}

.intro-section {
  text-align: center;
  padding: 40px 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.intro-section h2 {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
}

.intro-section p {
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
  line-height: 1.5;
}

.btn-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 30px;
}

.start-test-btn {
  width: 100%;
  background: #738cfc;
  color: #fff;
  border: none;
  padding: 15px 30px;
  border-radius: 30px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 178, 255, 0.3);
  margin: 30px 0 50px 0;
}

.start-test-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 178, 255, 0.4);
}

.view-result-btn {
  background: #f0f4ff;
  color: #333;
  border: 1px solid #e0e0e0;
  padding: 15px 30px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-result-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.description-section {
  width: 100%;
  position: absolute;
  bottom: 0;
  height: calc(100vh - 200px);
  padding: 0 30px;
  background: linear-gradient(to bottom, #93a5fd 0%, #ffffff 40%);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.description-section h3 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.description-section p {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 15px;
  text-align: justify;
}
.hld-action-bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}
.section-content {
  position: relative;
  z-index: 2;
  width: 100%;
}
</style>